import styled, { css } from 'styled-components';

export const AnnouncementList = styled.div`
	width: 100%;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
`;

export const AnnouncementItem = styled.div<{ isLastItem?: boolean }>`
	width: 100%;
	padding: 15px 20px;

	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 5px;

	${({ isLastItem }) =>
		!isLastItem &&
		css`
			border-bottom: 1px solid ${({ theme }) => theme['warmgray-100']};
		`}
`;
